<template>
  <div v-if="employee" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="employee">
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <legend>
            <strong>Persönliche Angaben</strong>
          </legend>
          <b-form-group
            horizontal
            :label="$t('title')"
            label-for="title"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.title" type="text" :placeholder="$t('title')" />
          </b-form-group>

          <b-form-group
            horizontal
            :label="$t('lastname')"
            label-for="lastname"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.lastname" type="text" :placeholder="$t('lastname')" />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('birthName')"
            label-for="birthName"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.birthName" type="text" :placeholder="$t('birthName')" />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('firstname')"
            label-for="firstname"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.firstname" type="text" :placeholder="$t('firstname')" />
          </b-form-group>

          <b-form-group
            horizontal
            :label="$t('dateOfBirth')"
            label-for="dateOfBirth"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <Calendar
              v-model="formattedDateOfBirth"
              id="dateOfBirth"
              show-icon
              dateFormat="dd.mm.yy"
              placeholder="TT.MM.JJJJ"
              :manualInput="false"
              class="custom-datepicker"
            >
            </Calendar>
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('placeOfBirth')"
            label-for="placeOfBirth"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.placeOfBirth"
              type="text"
              :placeholder="$t('placeOfBirth')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('countryOfOrigin')"
            label-for="countryOfOrigin"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.countryOfOrigin"
              type="text"
              :placeholder="$t('countryOfOrigin')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('gender')"
            label-for="gender"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <multiselect
              :placeholder="$t('gender') + ' ' + $t('select')"
              v-model="employee.gender"
              :options="getEnumValues('Gender')"
              :show-labels="true"
              :allow-empty="false"
              :taggable="true"
              :selectLabel="$t('select')"
              :selectedLabel="$t('selected')"
              :deselectLabel="$t('remove_selection')"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <b-badge>{{ $t(option) }}</b-badge>
              </template>
              <template slot="option" slot-scope="{ option }">
                <b-badge>{{ $t(option) }}</b-badge>
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('maritialStatus')"
            label-for="maritialStatus"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <multiselect
              :placeholder="$t('maritialStatus') + ' ' + $t('select')"
              v-model="employee.maritialStatus"
              :options="getEnumValues('MaritialStatus')"
              :show-labels="true"
              :allow-empty="false"
              :taggable="true"
              :selectLabel="$t('select')"
              :selectedLabel="$t('selected')"
              :deselectLabel="$t('remove_selection')"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><b-badge>{{ $t(option) }}</b-badge></template
              >
              <template slot="option" slot-scope="{ option }">
                <b-badge>
                  {{ $t(option) }}
                </b-badge></template
              >
            </multiselect>
          </b-form-group>

          <b-form-group
            horizontal
            :label="$t('nationality')"
            label-for="nationality"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.nationality"
              type="text"
              :placeholder="$t('nationality')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('motherTongue')"
            label-for="motherTongue"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.motherTongue"
              type="text"
              :placeholder="$t('motherTongue')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('languagesOfCommunication')"
            label-for="languagesOfCommunication"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.languagesOfCommunication"
              type="text"
              :placeholder="$t('exampleLanguages')"
            />
          </b-form-group>
          <legend>
            <strong> Bankverbindung</strong>
          </legend>
          <b-form-group
            horizontal
            :label="$t('bankAccountNumber')"
            label-for="bankAccountNumber"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.bankAccountNumber"
              type="text"
              :placeholder="$t('bankAccountNumber')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('sortCode')"
            label-for="sortCode"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.sortCode" type="text" :placeholder="$t('sortCode')" />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('bic')"
            label-for="bic"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.bic" type="text" :placeholder="$t('bic')" />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('iban')"
            label-for="iban"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.iban" type="text" :placeholder="$t('iban')" />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('nameOfBank')"
            label-for="nameOfBank"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.nameOfBank"
              type="text"
              :placeholder="$t('nameOfBank')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('altAccHolder')"
            label-for="altAccHolder"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.altAccHolder"
              type="text"
              :placeholder="$t('altAccHolder')"
            />
          </b-form-group>
          <legend>
            <strong>Lohnsteuerdaten</strong>
          </legend>
          <b-form-group
            horizontal
            :label="$t('taxNumber')"
            label-for="taxNumber"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input v-model="employee.taxNumber" type="text" :placeholder="$t('taxNumber')" />
          </b-form-group>
          <legend>
            <strong>Rentenversicherung</strong>
          </legend>
          <b-form-group
            horizontal
            :label="$t('socialSecurityNr')"
            label-for="socialSecurityNr"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.socialSecurityNr"
              type="text"
              :placeholder="$t('socialSecurityNr')"
            />
          </b-form-group>
          <legend>
            <strong>Krankenversicherung gesetzlich</strong>
          </legend>
          <b-form-group
            horizontal
            :label="$t('healthInsurance')"
            label-for="healthInsurance"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.healthInsurance"
              type="text"
              :placeholder="$t('healthInsurance')"
            />
          </b-form-group>
          <legend>
            <strong>Krankenversicherung privat</strong>
          </legend>
          <b-form-group
            horizontal
            :label="$t('privateHealthInsurance')"
            label-for="privateHealthInsurance"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.privateHealthInsurance"
              type="text"
              :placeholder="$t('privateHealthInsurance')"
            />
          </b-form-group>
          <b-form-group
            horizontal
            :label="$t('lastHealthInsurance')"
            label-for="lastHealthInsurance"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="employee.lastHealthInsurance"
              type="text"
              :placeholder="$t('lastHealthInsurance')"
            />
          </b-form-group>
        </b-col>
        <b-col lg="6" md="6" sm="12">
          <legend>
            <strong>{{ $t('state') }}</strong>
          </legend>

          <b-form-group
            horizontal
            :label="$t('state')"
            label-for="activeState"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <multiselect
              :placeholder="$t('state') + ' ' + $t('select')"
              v-model="employee.activeState"
              :options="getEnumValues('ActiveState')"
              :show-labels="true"
              :allow-empty="false"
              :taggable="true"
              :selectLabel="$t('select')"
              :selectedLabel="$t('selected')"
              :deselectLabel="$t('remove_selection')"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><b-badge :variant="getActiveStateColor(option)">{{
                  $t(option)
                }}</b-badge></template
              >
              <template slot="option" slot-scope="{ option }">
                <b-badge :variant="getActiveStateColor(option)">
                  {{ $t(option) }}
                </b-badge></template
              >
            </multiselect>
          </b-form-group>

          <legend>
            <strong>{{ $t('users') }}</strong>
          </legend>

          <b-form-group
            horizontal
            :label="$t('users')"
            label-for="activeState"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <multiselect
              class="multiselect-users"
              v-model="employee.users"
              :options="filteredUsers"
              track-by="number"
              v-on:search-change="onFilterUsers"
              v-on:select="onSelectUser"
              v-on:remove="onSelectUser"
              :filter="true"
              :internal-search="false"
              :close-on-select="false"
              :clear-on-select="false"
              :multiple="true"
              :show-labels="false"
              :allow-empty="true"
              :deselectLabel="$t('deselectLabel')"
              selectLabel=""
              selectedLabel=""
              :placeholder="'Benutzer ' + $t('select') + '/suchen'"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.firstname }} {{ option.lastname }} - {{ option.email }}
              </template>
              <template slot="option" slot-scope="{ option }">
                {{ option.firstname }} {{ option.lastname }} - {{ option.email }}
              </template>
              <template slot="tag" slot-scope="{ option }">
                <div>{{ option.firstname }} {{ option.lastname }} - {{ option.email }}</div>
              </template>
              <template slot="noResult">
                <div>{{ $t('no_results') }}</div>
              </template>
            </multiselect>
          </b-form-group>
          <legend>
            <legend>
              <strong>Kontakt</strong>
            </legend>
            <b-form-group
              horizontal
              :label="$t('mobile')"
              label-for="mobilePhone"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.mobilePhone"
                type="text"
                :placeholder="$t('mobile')"
              />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('email')"
              label-for="email"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.email" type="text" :placeholder="$t('email')" />
            </b-form-group>
            <legend>
              <strong>Aktuelle Anschrift (Hauptwohnsitz)</strong>
            </legend>
            <b-form-group
              horizontal
              :label="$t('streetAndNumber')"
              label-for="street"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.street"
                type="text"
                :placeholder="$t('streetAndNumber')"
              />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('zip')"
              label-for="zip"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.zip" type="text" :placeholder="$t('zip')" />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('addition')"
              label-for="addition"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.addition" type="text" :placeholder="$t('addition')" />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('district')"
              label-for="district"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.district" type="text" :placeholder="$t('district')" />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('city')"
              label-for="city"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.city" type="text" :placeholder="$t('city')" />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('phone')"
              label-for="phone"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.phone" type="text" :placeholder="$t('phone')" />
            </b-form-group>
            <legend>
              <strong>Zweitanschrift / Nebenwohnsitz (z.B. doppelte Haushaltsführung)</strong>
            </legend>
            <b-form-group
              horizontal
              :label="$t('streetAndNumber')"
              label-for="street2"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.street2"
                type="text"
                :placeholder="$t('streetAndNumber')"
              />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('zip')"
              label-for="zip"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.zip2" type="text" :placeholder="$t('zip')" />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('addition')"
              label-for="addition"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.addition2"
                type="text"
                :placeholder="$t('addition')"
              />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('district')"
              label-for="district"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.district2"
                type="text"
                :placeholder="$t('district')"
              />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('city')"
              label-for="city"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.city2" type="text" :placeholder="$t('city')" />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('phone')"
              label-for="phone"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input v-model="employee.phone2" type="text" :placeholder="$t('phone')" />
            </b-form-group>
            <legend>
              <strong>Notfall / Bezugsperson</strong>
            </legend>
            <b-form-group
              horizontal
              :label="$t('emergencyContact')"
              label-for="emergencyContact"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.emergencyContact"
                type="text"
                :placeholder="$t('emergencyContact')"
              />
            </b-form-group>
            <b-form-group
              horizontal
              :label="$t('emergencyPhone')"
              label-for="emergencyPhone"
              label-class="text-md-right"
              :label-cols="4"
              breakpoint="md"
            >
              <b-form-input
                v-model="employee.emergencyPhone"
                type="text"
                :placeholder="$t('emergencyPhone')"
              />
            </b-form-group>
          </legend>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :model="employee"
            modelEditRoute="EmployeeEditPage"
            modelListRoute="EmployeesPage"
            modelRouteParamName="employeeNumber"
            :updateCallback="updateEmployee"
            :createCallback="createEmployee"
            :deleteCallback="deleteEmployee"
            :fetchPaginatedCallback="fetchEmployees"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import ButtonBar from '@/components/ButtonBar.vue';
import { getActiveStateColor } from '@/helpers/colors';
import Calendar from 'primevue/calendar';

export default {
  name: 'EmployeeEditPage',
  components: {
    Widget,
    Breadcrumbs,
    Multiselect,
    ButtonBar,
    Calendar,
  },
  props: {
    employeeNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
      filteredUsers: [],
      dateOfBirth: null,
    };
  },
  computed: {
    ...mapGetters(['getEmployee', 'getEmployeeByNumber', 'getEnumValues', 'getUsers']),
    buttons() {
      return {
        showDeleteButton: this.employee && this.employee.number !== '_new' ? true : false,
      };
    },
    formattedDateOfBirth: {
      get() {
        return this.employee.dateOfBirth ? new Date(this.employee.dateOfBirth) : null;
      },
      set(value) {
        this.employee.dateOfBirth = value;
      },
    },
    employee() {
      return this.getEmployeeByNumber(this.number);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('employee'), route: { name: 'EmployeesPage' } },
        { name: this.employee.number !== '_new' ? this.$t('edit') : this.$t('new') },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchEmployees',
      'fetchEmployeeByNumber',
      'updateEmployee',
      'createEmployee',
      'deleteEmployee',
      'fetchEnumValues',
      'initEmployee',
      'fetchUsers',
    ]),
    /**
     *
     */
    async onFilterUsers(query) {
      console.log(query);
      this.filteredUsers = [];
      this.getUsers.map((user) => {
        if (
          (user.firstname && user.firstname.toLowerCase().indexOf(query) >= 0) ||
          (user.lastname && user.lastname.toLowerCase().indexOf(query) >= 0)
        ) {
          console.log(user);
          this.filteredUsers.push(user);
        }
      });
    },
    /**
     *
     */
    async onSelectUser(user) {
      console.log(user);
      // const { data } = user;
      // this.save(data);
    },

    /**
     *
     */
    // async save(employee) {
    //   if (employee.number === '_new') {
    //     await this.createEmployee(employee);
    //   } else {
    //     await this.updateEmployee(employee);
    //   }
    // },

    getActiveStateColor,
  },
  async mounted() {
    await this.fetchEnumValues('ActiveState');
    await this.fetchEnumValues('Gender');
    await this.fetchEnumValues('MaritialStatus');
    await this.fetchUsers();

    if (!this.employee && this.employeeNumber) {
      this.number = this.employeeNumber;
      await this.fetchEmployeeByNumber(this.number);
    } else {
      this.initEmployee();
      this.number = '_new';
    }

    this.filteredUsers = this.getUsers;
  },
};
</script>

<style scoped lang="scss">
.custom-datepicker {
  width: 100%;
}

.custom-datepicker .p-inputtext {
  height: 38px; /* Gleiche Höhe wie normale Bootstrap-Inputs */
  padding: 6px 12px; /* An Standard anpassen */
  font-size: 1rem;
}
</style>
